// --- components/search/SearchResults.jsx ---
import React, { useState, useEffect } from 'react';
import SponsoredCard from './SponsoredCard';
import LoggedInCard from './LoggedInCard';

export default function SearchResults({ results, zip, radius, user }) {
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 6; // ✅ Updated from 3 to 6

  useEffect(() => {
    setCurrentPage(1); // Reset to first page on new results
  }, [results]);

  if (!Array.isArray(results) || results.length === 0) {
    return (
      <div className="text-center text-gray-600 italic mt-4">
        Seems like the stable is empty. Try expanding your search.
      </div>
    );
  }

  const totalPages = Math.ceil(results.length / resultsPerPage);
  const startIndex = (currentPage - 1) * resultsPerPage;
  const currentResults = results.slice(startIndex, startIndex + resultsPerPage);

  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-3">
        Results for {zip} within {radius} miles
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {currentResults.map((horse, i) => {
          const props = {
            id: horse._id,
            name: horse.horseInfo?.name,
            breed: horse.horseInfo?.breed,
            age: horse.horseInfo?.age,
            sex: horse.horseInfo?.sex,
            height: horse.horseInfo?.height?.hands,
            color: horse.horseInfo?.color,
            images: horse.horseInfo?.images || [],
            price: horse.saleInfo?.buyNowPrice || horse.saleInfo?.auctionStartingPrice,
            status: horse.status,
            location: horse.horseInfo?.location,
            sale: horse.saleInfo?.saleType
          };

          return user ? (
            <LoggedInCard key={`search-${horse._id || i}`} horse={props} />
          ) : (
            <SponsoredCard key={`search-${horse._id || i}`} horse={props} />
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-6 gap-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
        >
          ← Prev
        </button>
        <span className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
        >
          Next →
        </button>
      </div>
    </div>
  );
}